import { createSelector } from '@ngrx/store';

import { CompanySelectors } from '../app-entities/company-users/company.selectors';
import { FeatureFlagKeys } from '../app-entities/feature-flag/feature-flag-state.model';
import { featureFlagSelectors } from '../app-entities/feature-flag/feature-flag-state.selectors';

/**
 * Whether Quarterly Discussions (Reviews on mobile) is available to the current company.
 *
 * Mirrors web's rule: the setting only bites for EOS Pure companies, and an absent setting is off.
 * A company configuration check, not an entitlement check — the two gate different things.
 */
export const selectQuarterlyDiscussionsAvailable = createSelector(
  CompanySelectors.selectCompanySettings,
  featureFlagSelectors.selectById(FeatureFlagKeys.enableEosPure),
  (settings, eosPureEnabled): boolean => !eosPureEnabled || settings?.quarterlyDiscussions === true
);
